import tenent from "./tenent";
import { Roles } from "helpers/enum.helpers";

const menuItems: any = {
  [Roles.SuperAdmin]: [tenent],
};

export default menuItems;
